export const SET_COURSES_OVERVIEW = 'SET_COURSES_OVERVIEW'
export const SET_COURSES_OVERVIEW_LOADING = 'SET_COURSES_OVERVIEW_LOADING'
export const SET_COURSES_OVERVIEW_STALE = 'SET_COURSES_OVERVIEW_STALE'
export const SET_COURSES_OVERVIEW_FRESH = 'SET_COURSES_OVERVIEW_FRESH'
export const SET_WHERE_YOU_LEFT_FETCHED = 'SET_WHERE_YOU_LEFT_FETCHED'
export const SET_WHERE_YOU_LEFT_DATA = 'SET_WHERE_YOU_LEFT_DATA'
export const SET_COMPLETED_COURSES_FETCHED = 'SET_COMPLETED_COURSES_FETCHED'
export const SET_COMPLETED_COURSES = 'SET_COMPLETED_COURSES'
export const SET_MESSAGES_FETCHED = 'SET_MESSAGES_FETCHED'
export const SET_MANAGERS_OVERVIEW = 'SET_MANAGERS_OVERVIEW'
export const SET_MANAGERS_OVERVIEW_FETCHED = 'SET_MANAGERS_OVERVIEW_FETCHED'
export const SET_REWARDS_FETCHED = 'SET_REWARDS_FETCHED'
export const SET_REWARDS = 'SET_REWARDS'
export const SET_RESTAURANT_PROGRESS_FETCHED = 'SET_RESTAURANT_PROGRESS_FETCHED'
export const SET_RESTAURANT_PROGRESS = 'SET_RESTAURANT_PROGRESS'
export const SET_COURSES_OVERVIEW_FETCHED = 'SET_COURSES_OVERVIEW_FETCHED'
export const SET_PROMOTED_COURSES_FETCHED = 'SET_PROMOTED_COURSES_FETCHED'
export const SET_PROMOTED_COURSES = 'SET_PROMOTED_COURSES'
export const SET_MANAGER_APPROVAL_FETCHED = 'SET_MANAGER_APPROVAL_FETCHED'
export const SET_SKIP_LOCATIONS = 'SET_SKIP_LOCATIONS'
export const RESET_SKIP = 'RESET_SKIP'
export const SET_SPECIFIC_SKIP_LOCATIONS = 'SET_SPECIFIC_SKIP_LOCATIONS'
